export default __webpack_public_path__ + "static/media/login-background-image.9db003a8.jpg";